import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'
import { ScreenContext } from '@hb/react'
import {
  assessmentTemplatesCollection,
  authAppealsTemplatesCollection,
  authInstructionsTemplatesCollection,
  claimTemplatesCollection,
  clinicalsTemplatesCollection,
  invoiceTemplatesCollection,
} from '@hb/shared'
import React, { useContext, useState } from 'react'
import { SelectedTemplate, TemplateContext } from '../../contexts/TemplateContext'
import { PageContainer } from '../Views/PageContainer'
import { AdminConsentFormsView } from './ConsentForms'
import { AdminPracticeContractsView } from './PracticeContracts'
import { TemplateEditorModal } from './TemplateEditModal'
import { TemplatesSection } from './TemplatesSection'
import { TemplatesViewProvider } from './TemplatesViewContext'

export const TemplatesView: React.FC = () => {
  const [selected, setSelected] = useState<SelectedTemplate | null>(null)
  const { height } = useContext(ScreenContext)
  const select = (c: SelectedTemplate) => {
    setSelected(c)
  }
  const deselect = () => {
    setSelected(null)
  }

  return (
    <TemplatesViewProvider>
      <PageContainer fullWidth contentProps={{ maxWidth: '1200px' }} noFooter>
        <Tabs
          isLazy
          borderRadius={4}
          boxShadow="md"
          w="100%"
          position="relative"
          background="white">
          <TemplateContext.Provider
            value={{
              selected,
              select,
              deselect,
            }}>
            <Box borderBottom="1px solid #cdcdcd" py={2} px={4}>
              <Text fontSize="lg">Templates</Text>
            </Box>
            <TabList>
              <Tab>Assessments</Tab>
              <Tab>Claims</Tab>
              <Tab>Clinicals</Tab>
              <Tab>Auth Appeals</Tab>
              <Tab>Auth Instructions</Tab>
              <Tab>Invoices / Receipts</Tab>
              <Tab>Consent Forms</Tab>
              <Tab>Practice Contracts</Tab>
            </TabList>
            <TabPanels position="relative" height={`${height - 200}px`} overflowY="auto">
              <TabPanel p={0}>
                <TemplatesSection
                  collection={assessmentTemplatesCollection}
                  templateType="assessments"
                />
              </TabPanel>
              <TabPanel p={0}>
                <TemplatesSection collection={claimTemplatesCollection} templateType="claims" />
              </TabPanel>
              <TabPanel p={0}>
                <TemplatesSection
                  collection={clinicalsTemplatesCollection}
                  templateType="clinicals"
                />
              </TabPanel>
              <TabPanel p={0}>
                <TemplatesSection
                  collection={authAppealsTemplatesCollection}
                  templateType="authAppeals"
                />
              </TabPanel>
              <TabPanel p={0}>
                <TemplatesSection
                  collection={authInstructionsTemplatesCollection}
                  templateType="authInstructions"
                />
              </TabPanel>
              <TabPanel p={0}>
                <TemplatesSection
                  collection={invoiceTemplatesCollection}
                  templateType="invoiceAndReceipt"
                />
              </TabPanel>
              <TabPanel p={0}>
                <AdminConsentFormsView />
              </TabPanel>
              <TabPanel p={0}>
                <AdminPracticeContractsView />
              </TabPanel>
            </TabPanels>
          </TemplateContext.Provider>
          {selected ? (
            <TemplateEditorModal
              templateId={selected.templateId}
              templateType={selected.templateType}
              templatePracticeId={null}
              isOpen
              onClose={deselect}
            />
          ) : null}
        </Tabs>
      </PageContainer>
    </TemplatesViewProvider>
  )
}
